import { render, staticRenderFns } from "./CmgFooterLink.vue?vue&type=template&id=29d88f88&scoped=true&lang=pug&"
import script from "./cmg-footer-link.ts?vue&type=script&lang=ts&"
export * from "./cmg-footer-link.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFooterLink.vue?vue&type=style&index=0&id=29d88f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d88f88",
  null
  
)

export default component.exports